<script setup lang="ts">
import { nextTick, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";
import { logout } from "@app/api/auth";
import { changeCurrentPassword } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { clearDynamicRoutes } from "@shared/router/installGuards";
import { useAuthStore } from "@shared/store/modules/auth";
import { t } from "@shared/utils/i18n";
import SystemChangePasswordDialog from "@shared/views/system/personalCenter/components/SystemChangePasswordDialog.vue";

defineOptions({ name: "ForceChangePasswordHost" });

const router = useRouter();
const auth = useAuthStore();
const currentUserStore = useCurrentUserStore();
const dialogRef = ref<InstanceType<typeof SystemChangePasswordDialog>>();

watch(
    () => currentUserStore.forceChangePassword,
    async need => {
        if (!need) return;
        // 极端时序：Host 刚挂载 ref 可能尚未就绪，最多补一次 nextTick
        for (let attempt = 0; attempt < 2; attempt++) {
            await nextTick();
            if (dialogRef.value) {
                dialogRef.value.open();
                break;
            }
        }
    },
    { immediate: true },
);

async function handleSuccess() {
    try {
        await logout();
    } catch {
        // 远端登出失败仍清理本地态
    }
    await auth.logout();
    currentUserStore.reset();
    clearDynamicRoutes(router);
    await router.replace("/login");
    ElMessage.success(t("请使用新密码登录"));
}
</script>

<template>
    <SystemChangePasswordDialog ref="dialogRef" force :submit-api="changeCurrentPassword" @success="handleSuccess" />
</template>
